export default {
  title: 'Galeria',
  sections: {
    logo: 'Logo',
    web_images: 'Zdjęcia galerii – zamawianie online',
  },
  toasts: {
    image_uploaded: 'Zmiany zostały pomyślnie zapisane',
    image_upload_failed: 'Nie udało się zapisać zmian',
  },
};
